import { InjectionToken, Provider } from '@angular/core';

export const CONFIG_API_BASE_URL = new InjectionToken<string>('Config API Base URL');

export const provideConfigApiBaseUrl = (baseUrl: string): Provider => ({
  provide: CONFIG_API_BASE_URL,
  useValue: baseUrl,
});
